// 特惠寄--商家寄件
import request from '@/utils/request';
// 查询订单列表
export function querySpecialOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/positiveOrder/queryOrder',
    method: 'post',
    data
  });
}
// 创建订单
export function createSpecialOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/positiveOrder/createOrder',
    method: 'post',
    data
  });
}
// 取消订单
export function cancelSpecialOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/positiveOrder/cancelOrder',
    method: 'post',
    data
  });
}
// 批量取消订单
export function batchCancelSpecialOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/positiveOrder/batchCancelOrder',
    method: 'post',
    data
  });
}
// 更新订单
export function changeSpecialOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/positiveOrder/changeOrderInfo',
    method: 'post',
    data
  });
}
// 合并订单
export function mergeSpecialOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/positiveOrder/mergeOrder',
    method: 'post',
    data
  });
}
// 打印订单--获取订单详情
export function printSpecialOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/positiveOrder/printOrder',
    method: 'post',
    data
  });
}
// 导入记录查询 
export function importResultRecordForSpecialOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/positiveOrder/queryUserImportResult',
    method: 'post',
    data
  });
}
// 订单导出--特惠寄
export function exportOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/positiveOrder/exportOrder',
    method: 'post',
    data
  });
}
// 导入文件上传--无发件人（导入接口耗时较长，超时时间 120s）
export function uploadImportFileApi(data) {
  return request({
    baseURL: '/khgj-file/',
    url: '/positiveOrderImport/uploadfile',
    method: 'post',
    data,
    timeout: 240000
  });
}
// 导入文件上传--有发件人（导入接口耗时较长，超时时间 120s）
export function uploadSendAndReceiveImportFileApi(data) {
  return request({
    baseURL: '/khgj-file/',
    url: '/positiveOrderImport/uploadSendAndReceiveFile',
    method: 'post',
    data,
    timeout: 240000
  });
}
